import { api } from './client';

export interface CatalogEntry {
  appid: number;
  title: string;
  description: string;
  store_url: string;
  tags: string[];
  server_type: string;
}

export interface WishlistEntry extends CatalogEntry {
  added_at: string;
  added_by: string;
}

export const fetchCatalog = (): Promise<CatalogEntry[]> =>
  api.get<{ catalog: CatalogEntry[] }>('/steam/catalog').then((r) => r.data.catalog);

export const fetchWishlist = (): Promise<WishlistEntry[]> =>
  api.get<{ wishlist: WishlistEntry[] }>('/wishlist').then((r) => r.data.wishlist);

export const addToWishlist = (appid: number): Promise<void> =>
  api.post('/wishlist', { appid }).then(() => undefined);

export const removeFromWishlist = (appid: number): Promise<void> =>
  api.delete(`/wishlist/${appid}`).then(() => undefined);
